export default {
  dir: 'rtl',
  welcome: 'خوش آمدید',
  phone: 'شماره موبایل',
  login: 'ورود',
  editPhone: 'ویرایش شماره موبایل',
  verify:'صحت سنجی',
  requiredPhone: "شماره موبایل را وارد کنید",
  invalidPhone: "فرمت شماره موبایل صحیح نیست"
 

}
